export const getMenu = () => {
  const menuHeight = 158;
  const menu = document.querySelector(".menu");
  const scrollButton = document.getElementById("scroll-button");

  window.addEventListener("scroll", function () {
    if (window.scrollY > menuHeight) {
      menu.classList.add("menu-scrolled");
      scrollButton.classList.remove("d-none");
    }
    if (window.scrollY < menuHeight) {
      menu.classList.remove("menu-scrolled");
      scrollButton.classList.add("d-none");
    }
  });
};

export const closeMenu = () => {
  const toggleMenu = document.getElementById("toggle-menu");
  const menuList = document.querySelector(".menu-list");

  document.addEventListener("click", function (event) {
    if (!menuList.contains(event.target) && !toggleMenu.contains(event.target)) {
      menuList.classList.add("menu-list-hidden");
    }
  });
};

export const toggleMobileMenu = () => {
  const menu = document.querySelector(".menu-list");
  const toggleMenu = document.getElementById("toggle-menu");
  
  toggleMenu.addEventListener("click", function (event) {
    event.preventDefault();
    menu.classList.toggle('menu-list-hidden');
  });
};

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".menu-list a");
  let currentPath = window.location.pathname;
  links.forEach(link => {
    if (currentPath != "/") {
      currentPath = currentPath.replace("/", "");
    }
    if (link.getAttribute("href") === currentPath) {
      link.classList.add("active");
    }
  });
});
